module.exports = __webpack_public_path__ + "img/1527841350.5fbed324.jpg";